import type { IBlockRichTextProps } from "./BlockRichText.props";

export const BlockRichText = ({ className, content }: IBlockRichTextProps) => (
  <div className={className} dangerouslySetInnerHTML={{ __html: content }} />
);

BlockRichText.displayName = "Shared::BlockRichText";
